<template>
  <v-menu 
    left
    top
    :close-on-content-click = "false"
  >
    <template v-slot:activator = "{ on, attrs }">
      <v-btn icon
             dark
             v-bind = "attrs"
             v-on   = "on"
      >
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item-group multiple
                         :value  = "selectedMarks"
                         @change = "setMarks"
      >
        <v-list-item v-for  = "attribute in filteredMarks"
                     color  = "primary"
                     :key   = "attribute"
                     :value = "attribute"
        >
          <template v-slot:default = "{ active }">
            <v-list-item-action>
              <v-checkbox :input-value = "active"></v-checkbox>
            </v-list-item-action>
            <div style = "display: flex; flex-direction: row; justify-content: space-between; width: 100%">
              <div style = "width: 100px">{{ attribute }}</div>

              <div v-if  = "attribute === waveformElements.GOP"
                   class = "gop-marks-container"
              >
                <div
                  class  = "square-shape-marker"
                  :style = "{ backgroundColor: waveformMarksColors.I_FRAME }"
                ></div>
                <div
                  class  = "square-shape-marker"
                  :style = "{ backgroundColor: waveformMarksColors.P_FRAME }"
                ></div>
                <div
                  class  = "square-shape-marker"
                  :style = "{ backgroundColor: waveformMarksColors.B_FRAME }"
                ></div>
              </div>

              <div
                v-if   = "attribute === waveformElements.SCTE_35"
              >
                <v-icon medium
                        :color="waveformMarksColors.SCTE_35"
                >mdi-map-marker</v-icon>
              </div>

              <div
                v-if   = "attribute === waveformElements.SCTE_104"
              >
                <v-icon medium
                        :color="waveformMarksColors.SCTE_104"
                >mdi-map-marker</v-icon>
              </div>
            </div>

            <div
              v-if   = "attribute === waveformElements.NIELSEN"
            >
              <v-icon medium
                      :color="waveformMarksColors.NIELSEN"
              >mdi-map-marker</v-icon>
            </div>

            <div v-if="attribute === waveformElements.CLIPS">
              <v-icon medium>mdi-content-cut</v-icon>
            </div>

            <div v-if="attribute === waveformElements.ANNOTATIONS">
              <v-icon medium>mdi-tag</v-icon>
            </div>

          </template>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>

/* vuex */
import {mapState} from 'vuex';

import { WAVEFORM_ELEMENTS, WAVEFORM_MARKS_COLORS } from '@/utils/constants';
import { SELECT_WAVEFORM_MARKS } from '@/utils/action-types';

export default {
  name: 'WaveformMarks',
  data: function () {
    return {
      marks: [
        WAVEFORM_ELEMENTS.SCTE_35,
        WAVEFORM_ELEMENTS.SCTE_104,
        WAVEFORM_ELEMENTS.NIELSEN,
        WAVEFORM_ELEMENTS.GOP,
        WAVEFORM_ELEMENTS.WAVEFORM,
        WAVEFORM_ELEMENTS.CLIPS,
        WAVEFORM_ELEMENTS.ANNOTATIONS
      ],
      hidden:              [],
      waveformElements:    WAVEFORM_ELEMENTS,
      waveformMarksColors: WAVEFORM_MARKS_COLORS,
    };
  },
  computed: {
    ...mapState([
      'experimentalFeatures'
    ]),
    selectedMarks() {
      return this.$store.state.video.selectedWaveformMarks;
    },
    filteredMarks() {
      let hidden = this.hiddenMarks;
      return this.marks.filter(m => hidden ? !hidden.includes(m) : true);
    },
    hiddenMarks() {
      const hidden = [];
      if (this.experimentalFeatures && !this.experimentalFeatures.annotations) {
        hidden.push('Annotations');
      }
      return hidden;
    },
  },
  methods: {
    setMarks(marks) {
      this.$store.dispatch(SELECT_WAVEFORM_MARKS, marks);
    },
    
  },
};
</script>

<style scoped>
.square-shape-marker {
  width        : 5px;
  padding-left : 3px;
  height       : 100%;
}

.flag-shape-marker {
  width         : 0;
  height        : 0;
  border-top    : 7px solid transparent;
  border-bottom : 7px solid transparent;
  position      : relative;
  transform     : translateX(7px);
}

.line {
  height    : 18px;
  transform : translateX(-20px);
  width     : 2px;
  position  : absolute;
  top       : 0;
}

.gop-marks-container {
  display        : flex;
  flex-direction : row;
  transform      : translate(4px);
}
</style>
